(function(){

  // SDL2 uses AudioContext.close, but currently doesn't check if it's supported by browser. (SDL_emscriptenaudio.c:234)
  if('AudioContext' in window) AudioContext.prototype.close = AudioContext.prototype.close || function(){};

  // Safari uses webkitAudioContext instead of AudioContext
  if('webkitAudioContext' in window) webkitAudioContext.prototype.close = webkitAudioContext.prototype.close || function(){};

})();

// polyfill for window.performance.now for browsers that doesn't support it (Safari on MacOS 10.9),
// emscripten uses window.performance.now to emulate monotonic clock
// for browsers that doesn't support it, steady_clock/high_resolution_clock effectively returns random value under emscripten.
// emscripten should throw exception in this case, but handling of exceptions is disabled, 
// and is seems that __throw_system_error from LLVM's libcxx defaults to nothing since no error message is displayed. Very helpful behavior.
(function(){
  if ("performance" in window == false) {
      window.performance = {};
  }
  
  Date.now = (Date.now || function () {  // thanks IE8
      return new Date().getTime();
  });

  if ("now" in window.performance == false){
    
    var nowOffset = Date.now();
    
    if (performance.timing && performance.timing.navigationStart){
      nowOffset = performance.timing.navigationStart
    }

    window.performance.now = function now(){
      return Date.now() - nowOffset;
    }
  }

})();

//workaround for https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
(function(){

  function addEventListenerRemoval(el, type, fn) {
    function handler(event) {
      if (fn(event)) return;
      el.removeEventListener(type, handler);
    }
    el.addEventListener(type, handler);
  }

  function resumeSound() {
    try {
      if (!SDL2 || !SDL2.audioContext) return true;
      if (!SDL2.audioContext.resume) return false;
      SDL2.audioContext.resume();
      return false;
    } catch (err) {}
    return false;
  }

  addEventListenerRemoval(document, "mousedown", resumeSound);
  addEventListenerRemoval(document, "keydown", resumeSound);
  addEventListenerRemoval(document, "click", resumeSound);

})();



//////////////////
// WEBPACK FOOTER
// /src/claw/sdk/src/claw/system/emscripten/Application.polyfill.js
// module id = 10
// module chunks = 0